module.exports = __webpack_public_path__ + "img/6.5d5a3147.jpg";